import React from 'react'

const Payments = () => {
  return (
    <div className='d-flex justify-content-center align-items-center text-center vh-100'>
    <h1>Hi, welcome to the Payments Module. We’re coming soon!</h1>
    </div>
  )
}

export default Payments ;